import React, { useState } from 'react';
import Navbar from '../../../components/navbar/Navbar';
import './employer-signup.css';
import signup from '../../../images/signup.svg'
import { FaEnvelope } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

import PageNavbar from '../../../components/navbar/Navbar';
import { Container, Col, Row, Form, Button} from 'react-bootstrap';

const Employersignup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(email, password); // log user input values
  };

  return (
    <div>
      <PageNavbar/>
      <Container fluid style={{background: '#FFA15E8C'}} className='p-0 m-0'>
        <Row>
          <Col md={6}>
            <img src={signup} alt='a woman' style={{width: '100%', height:'100%'}}className=''/>
          </Col>
          <Col md={6} className='px-5 justify-content-center align-items-center'>
            <div className='px-2 px-md-5'>
              <h2 className='login-head mt-5 text-center'> Sign Up</h2>

              <Form className='mt-5' onSubmit={handleSubmit}> 
             <Form.Group className="mb-4" controlId="formBasicEmail">
               <Form.Label className='label-form mb-2'>Email address:</Form.Label>
               <div className='input-box'>
               < FaEnvelope className='input-box-icon' />
                <Form.Control type="email" placeholder="cynthia@yahoo.com" value={email} onChange={(e) => setEmail(e.target.value)} className='input-box-container p-2 ps-5'/>
                </div>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label className='label-form mb-2'>Password:</Form.Label>
              <div className='input-box'>
              <FaLock className='input-box-icon' />
              <Form.Control type="password" placeholder="********" value={password} onChange={(e) => setPassword(e.target.value)}className='input-box-container p-2 ps-5'/>
              </div>
            </Form.Group>
            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label className='label-form mb-2'>Confirm Password:</Form.Label>
              <div className='input-box'>
              <FaLock className='input-box-icon' />
              <Form.Control type="password" placeholder="********" value={password} onChange={(e) => setPassword(e.target.value)}className='input-box-container p-2 ps-5'/>
              </div>
            </Form.Group>
            <Button onClick={() => navigate('/employerform1')}type="submit" className='login-btn py-3' style={{width:'100%'}}>
              Sign up
           </Button>
           <div className='d-flex mt-2 align-items-center '>
            
           <p>Are you a JobSeeker? Sign up <Link to='/jobseekersignup'><span>here</span></Link></p>
           
           </div>
             </Form>

             <div className='text-center mt-5 login-last'>
          <p className='login-last-p'>Already have an account? &nbsp;Sign in &nbsp;
            <Link to="/employerlogin">here</Link>
          </p>
          
          </div>
            
            </div>
          </Col>
        </Row>
      </Container>
     
    </div>
  );
};

export default Employersignup;

